import React from "react";

import { deepMerge } from "../../utils/objectUtils.js";
import { appSettingsModules } from "./registry.js";

export function getActiveAppSettingsModules(app, scope, apps) {
    return appSettingsModules.filter(
        (module) =>
            module.appliesToApp(app, apps) &&
            (module.scopes ?? ["app", "location", "task"]).includes(scope),
    );
}

export function buildAppSettingsSchema(activeSettingsModules, z) {
    return z.object({
        settings: z.object(
            Object.assign(
                {},
                ...activeSettingsModules.map((module) => module.schema.shape),
            ),
        ),
    });
}

export function getAppSettingsValues(activeSettingsModules, sourceApp) {
    const settings = sourceApp?.settings ?? {};

    return deepMerge(
        {},
        ...activeSettingsModules
            .map((module) => module.values(settings))
            .filter(Boolean),
    );
}

export default function AppSettingsFormFields({
    activeSettingsModules,
    control,
    errors,
    setValue,
    defaultAppSettings,
    extraContext = {},
}) {
    return (
        <>
            {activeSettingsModules.map(({ key, Component, getExtraProps }) => (
                <React.Fragment key={key}>
                    <Component
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        defaultAppSettings={defaultAppSettings}
                        {...(getExtraProps?.(extraContext) || {})}
                    />
                    <br />
                </React.Fragment>
            ))}
        </>
    );
}
